import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import MegaMenu from './MegaMenu';
import withSizes from 'react-sizes';

class HeaderBottom extends Component {

    constructor(props) {
        super(props);
        this.state = {
            mainNavMobileVisibility: false,
            subNavMobileVisibility: {}
        }

        this.renderMainNavDesktop = this.renderMainNavDesktop.bind(this);
        this.renderMegaMenusDesktop = this.renderMegaMenusDesktop.bind(this);
    }

    render() {
        const { isMobile } = this.props
        return (
            !isMobile
                ?
                <div className="header-bottom">
                    <div className="container">
                        <div className="row">
                            <div className="col-md-12 nav-bar">
                                {this.renderMainNavDesktop()}
                                {this.renderSubNav()}
                                {this.renderSocialLinksNav()}
                            </div>
                        </div>
                    </div>
                    {this.renderMegaMenusDesktop()}

                </div>
                :
                null
        );
    }

    renderMainNavDesktop() {

        const { mainMenuSet, activeMenu, setActiveMenu } = this.props;
        return (
            <div className="main-nav">
                <ul>
                    {mainMenuSet
                        ? Object.keys(mainMenuSet).map(menuId => {
                            let menu = mainMenuSet[menuId];
                            return (
                                <li key={menuId}>
                                    <a onClick={() => setActiveMenu(menuId)} className={`drop-down ${menuId === activeMenu
                                        ? 'active'
                                        : ''}`}>
                                        <div className={`icon ${menuId}`}><img src={menuId === activeMenu
                                            ? menu.activeIcon
                                            : menu.icon} 
                                            alt={menu.name}/></div>{menu.name}
                                    </a>
                                </li>
                            )
                        })
                        : null}
                </ul>
            </div>
        )
    }

    renderSubNav() {
        return (
            <div className="sub-nav">
                <ul>
                    <li>
                        <Link to="/products/newarrivals">New Arrivals</Link>
                    </li>
                    <li>
                        <Link to="/products/specials">Specials</Link>
                    </li>
                </ul>
            </div>
        )
    }

    renderSocialLinksNav() {
        return (
            <div className="social-links">
                <a href="https://twitter.com/@jasonsliquor" aria-label="jasonsliquor twitter link" target="_blank"><i className="fa fa-twitter" /></a>
                <a href="https://www.facebook.com/jasonsliquor/" aria-label="jasonsliquor facebook link" target="_blank"><i className="fa fa-facebook" /></a>
                <a href="https://www.instagram.com/jasonsliquor/" aria-label="jasonsliquor instagram link" target="_blank"><i className="fa fa-instagram" /></a>
                <a href="https://www.yelp.com/biz/jasons-wine-and-spirits-los-angeles" aria-label="jasonsliquor yelp link" target="_blank"><i className="fa fa-yelp" /></a>
            </div>
        )
    }

    renderMegaMenusDesktop() {

        const { mainMenuSet, activeMenu, setActiveMenu } = this.props;
        return mainMenuSet
            ? Object.keys(mainMenuSet).map(menuId => {
                let menu = mainMenuSet[menuId];
                return (<MegaMenu key={menuId} menuSet={menu.megaMenu} visibility={menuId === activeMenu} onClose={() => setActiveMenu('')} />)
            })
            : null;
    }
}

const mapSizesToProps = ({ width }) => ({
    isMobile: width < 992
});

export default withSizes(mapSizesToProps)(HeaderBottom);



// WEBPACK FOOTER //
// ./src/components/commons/header/HeaderBottom.js